export default {
  data() {
    return {
      showRegTypes: false,
    };
  },
};
